(() => {
  if (window.hmCrossSellPopup) return;

  const sources = [
    { root: '[data-hm-prio1-compact]', card: '.hm-prio1-compact__item', prefix: 'hm-prio1-compact' },
    { root: '[data-hm-mobile-upsell]', card: '.hm-mobile-buy__upsell-item', prefix: 'hm-mobile-buy__upsell' },
    { root: '[data-hm-secondary-upsell]', card: '.hm-secondary-upsell-card', prefix: 'hm-secondary-upsell-card', secondary: true },
  ];

  const readProducts = (scope, secondary, mainVariantId) => {
    const products = [];
    const seen = new Set();
    sources.filter((source) => Boolean(source.secondary) === secondary).forEach((source) => {
      scope.querySelectorAll(`${source.root} ${source.card}`).forEach((card) => {
        const field = card.querySelector(`.${source.prefix}__variant, .${source.prefix}__variant-id, .${source.prefix}-variant, .${source.prefix}-variant-id`);
        const title = card.querySelector(`.${source.prefix}__title, .${source.prefix}-title`);
        const image = card.querySelector(`.${source.prefix}__image, .${source.prefix}-image`);
        const price = card.querySelector(`.${source.prefix}__price, .${source.prefix}-price`);
        if (!field || !title) return;
        const variants = field.tagName === 'SELECT'
          ? Array.from(field.options).filter((option) => !option.disabled && /^\d+$/.test(option.value) && option.value !== mainVariantId)
          : /^\d+$/.test(field.value) && field.value !== mainVariantId ? [{ value: field.value, textContent: '', dataset: {} }] : [];
        const key = title.getAttribute('href')?.split('?')[0] || field.value;
        if (!variants.length || seen.has(key) || key === scope.dataset.url) return;
        seen.add(key);
        products.push({ title: title.textContent.trim(), url: title.getAttribute('href'), image: image?.currentSrc || image?.src, price: price?.textContent.trim() || '', eligible: !secondary || card.dataset.hmDiscountEligible === 'true', variants, selected: field.value });
      });
    });
    return products.slice(0, 2);
  };

  const popup = {
    isOpen: false,

    offer(productForm, mainResponse, mainVariantId) {
      const scope = productForm.closest('.hm-product-page');
      if (!scope || productForm.closest('quick-add-modal') || this.isOpen) return Promise.resolve(mainResponse);
      let products = readProducts(scope, false, String(mainVariantId));
      const secondary = !products.length;
      if (secondary) products = readProducts(scope, true, String(mainVariantId));
      if (!products.length) return Promise.resolve(mainResponse);

      const dialog = document.createElement('dialog');
      dialog.className = 'hm-cross-sell';
      dialog.setAttribute('aria-labelledby', 'hm-cross-sell-title');
      dialog.setAttribute('aria-describedby', 'hm-cross-sell-description');
      dialog.innerHTML = `
        <div class="hm-cross-sell__panel">
          <button type="button" class="hm-cross-sell__close" aria-label="Sluiten">×</button>
          <div class="hm-cross-sell__confirmation">
            <p class="hm-cross-sell__confirmation-label"><span class="hm-cross-sell__check" aria-hidden="true">✓</span>Toegevoegd aan je winkelwagen</p>
            <div class="hm-cross-sell__main-product"><img class="hm-cross-sell__main-image" alt=""><div><strong class="hm-cross-sell__main-title"></strong><span class="hm-cross-sell__main-variant" hidden></span><strong class="hm-cross-sell__main-price"></strong></div></div>
          </div>
          <div class="hm-cross-sell__head">
            <h2 id="hm-cross-sell-title"></h2>
            <span class="hm-cross-sell__discount">5% meebestelkorting</span>
          </div>
          <h3 class="hm-cross-sell__subtitle" hidden>Misschien ook interessant</h3>
          <p id="hm-cross-sell-description"></p>
          <div class="hm-cross-sell__products"></div>
          <p class="hm-cross-sell__status" role="status"></p>
          <p class="hm-cross-sell__error" role="alert" hidden></p>
          <button type="button" class="hm-cross-sell__continue">Verder winkelen</button>
        </div>`;
      const mainTitle = mainResponse.product_title || mainResponse.title || scope.dataset.productTitle || '';
      dialog.querySelector('.hm-cross-sell__main-title').textContent = mainTitle;
      const mainImage = dialog.querySelector('.hm-cross-sell__main-image');
      const imageUrl = mainResponse.featured_image?.url || mainResponse.image || scope.querySelector('.sticky-cta__image')?.currentSrc;
      if (imageUrl) { mainImage.src = imageUrl; mainImage.alt = mainTitle; }
      else mainImage.hidden = true;
      if (mainResponse.variant_title && mainResponse.variant_title !== 'Default Title') {
        const variant = dialog.querySelector('.hm-cross-sell__main-variant');
        variant.textContent = mainResponse.variant_title;
        variant.hidden = false;
      }
      const mainPrice = mainResponse.final_price ?? mainResponse.price;
      dialog.querySelector('.hm-cross-sell__main-price').textContent = typeof mainPrice === 'number'
        ? new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(mainPrice / 100)
        : '';
      dialog.querySelector('h2').textContent = secondary ? 'Ook handig' : 'Slim erbij';
      dialog.querySelector('.hm-cross-sell__discount').hidden = !products.some((product) => product.eligible);
      dialog.querySelector('.hm-cross-sell__subtitle').hidden = !secondary;
      dialog.querySelector('#hm-cross-sell-description').textContent = secondary
        ? scope.querySelector('.hm-secondary-upsell__header p')?.textContent.trim() || `Niet essentieel, wel vaak handig bij ${scope.dataset.productTitle || 'dit product'}.`
        : 'Handig bij dit product.';

      let latestResponse = mainResponse;
      let adding = false;
      const activeElement = document.activeElement;
      const hadScrollLock = document.body.classList.contains('overflow-hidden');

      return new Promise((resolve) => {
        const finish = () => {
          if (adding || !dialog.open) return;
          dialog.close();
        };
        dialog.addEventListener('close', () => {
          this.isOpen = false;
          document.body.classList.remove('hm-cross-sell-open');
          if (hadScrollLock) document.body.classList.add('overflow-hidden');
          dialog.remove();
          activeElement?.focus();
          resolve(latestResponse);
        }, { once: true });
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          finish();
        });
        dialog.querySelector('.hm-cross-sell__close').addEventListener('click', () => finish());
        dialog.querySelector('.hm-cross-sell__continue').addEventListener('click', finish);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) finish();
        });

        products.forEach((product) => {
          const card = document.createElement('article');
          card.className = 'hm-cross-sell__product';
          card.innerHTML = `<a class="hm-cross-sell__image-link"><img class="hm-cross-sell__image" alt=""></a><div class="hm-cross-sell__info"><a class="hm-cross-sell__product-title"></a><strong class="hm-cross-sell__price"></strong></div><button type="button" class="hm-cross-sell__add">Toevoegen</button>`;
          card.querySelectorAll('a').forEach((link) => { link.href = product.url; });
          card.querySelector('.hm-cross-sell__product-title').textContent = product.title;
          const image = card.querySelector('img');
          if (product.image) image.src = product.image;
          else image.hidden = true;
          const price = card.querySelector('.hm-cross-sell__price');
          price.textContent = product.price;
          const select = document.createElement('select');
          const button = card.querySelector('button');
          const addedQuantities = new Map();
          const updateButton = () => {
            const quantity = addedQuantities.get(select.value) || 0;
            button.textContent = quantity ? `✓ Toegevoegd (${quantity})` : 'Toevoegen';
            button.classList.toggle('hm-cross-sell__add--added', quantity > 0);
            button.setAttribute('aria-label', `${quantity ? 'Nog een' : ''} ${product.title} toevoegen`.trim());
          };
          select.className = 'hm-cross-sell__variant';
          select.setAttribute('aria-label', `Kies uitvoering voor ${product.title}`);
          product.variants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = variant.value;
            option.textContent = variant.textContent.trim();
            option.dataset.price = variant.dataset.price || product.price;
            option.dataset.image = variant.dataset.image || product.image || '';
            select.append(option);
          });
          if (product.variants.some((variant) => variant.value === product.selected)) select.value = product.selected;
          const updateVariant = () => {
            const option = select.selectedOptions[0];
            price.textContent = option.dataset.price;
            if (option.dataset.image) image.src = option.dataset.image;
            updateButton();
          };
          select.addEventListener('change', updateVariant);
          updateVariant();
          if (product.variants.length > 1) card.querySelector('.hm-cross-sell__info').append(select);

          button.addEventListener('click', async () => {
            if (adding) return;
            adding = true;
            dialog.setAttribute('aria-busy', 'true');
            dialog.querySelectorAll('button, select').forEach((control) => { control.disabled = true; });
            button.textContent = 'Toevoegen…';
            const error = dialog.querySelector('.hm-cross-sell__error');
            error.hidden = true;
            try {
              const sectionIds = Object.keys(latestResponse.sections || {});
              const response = await fetch(window.routes.cart_add_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: select.value, quantity: 1, ...(sectionIds.length ? { sections: sectionIds, sections_url: window.location.pathname } : {}) }),
              });
              const added = await response.json();
              if (!response.ok || added.status) throw new Error(added.description || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
              // Keep every addition in Shopify and keep offering the other products.
              latestResponse = added;
              addedQuantities.set(select.value, (addedQuantities.get(select.value) || 0) + 1);
              dialog.querySelector('.hm-cross-sell__status').textContent = `${product.title} toegevoegd aan je winkelwagen.`;
            } catch (cause) {
              error.textContent = cause.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
              error.hidden = false;
            } finally {
              updateButton();
              adding = false;
              dialog.removeAttribute('aria-busy');
              dialog.querySelectorAll('button, select').forEach((control) => { control.disabled = false; });
            }
          });
          dialog.querySelector('.hm-cross-sell__products').append(card);
        });

        document.body.append(dialog);
        // A native modal also traps focus and keeps the underlying ATC buttons inert.
        dialog.showModal();
        this.isOpen = true;
        document.querySelector('cart-drawer.active')?.close();
        document.querySelector('cart-notification')?.notification?.classList.contains('active') && document.querySelector('cart-notification').close();
        document.body.classList.add('hm-cross-sell-open');
        dialog.querySelector('.hm-cross-sell__add').focus();
      });
    },
  };

  window.hmCrossSellPopup = popup;
})();
